<template>
  <NavigationLayout
    :navigationBarStyle="{
      'border-bottom': '1px solid #e8e8e8',
    }"
  >
    <div id="mypage__wrapper" slot="contents">
      <div class="complete_img">
        <img src="/img/check.png" />
      </div>
      <div id="mypage__container">
        <p class="exchange_complete">
          {{ $t('vipPointCompleteLabelTitle') }}
        </p>
        <p class="exchange_thanks">
          {{
            $t('vipPointCompleteLabelDescription', {
              item: itemName,
            })
          }}
        </p>
        <PrimaryButton @click.native="moveTo({ name: 'vip_point_shop' })">
          {{ $t('vipPointCompleteButtonBackToShop') }}
        </PrimaryButton>
      </div>
    </div>
  </NavigationLayout>
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import NavigationLayout from '@/components/NavigationLayout.vue'
import PrimaryButton from '@/components/PrimaryButton.vue'
import { LanguageQueryHandler } from '@/mixins/LanguageQuery'
import { RawLocation } from 'vue-router'

@Component({
  components: {
    NavigationLayout,
    PrimaryButton,
  },

  // 交換画面からしか遷移できない
  beforeRouteEnter(_to, from, next) {
    const transitions = ['vip_point_shop']
    if (!from.name || !transitions.includes(from.name)) {
      return next({ name: 'vip_point_shop' })
    }
    next()
  },
})
export default class VipPointShopComplete extends Mixins(LanguageQueryHandler) {
  itemName: string = ''

  created() {
    this.itemName = (this.$route.query.itemName as string) || ''
  }

  moveTo(location: RawLocation) {
    this.$router.push(location).catch(() => {
      // Nothing to do
    })
  }
}
</script>

<style scoped>
.complete_img {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  margin-top: 56px;
}

.complete_img img {
  width: 100%;
  max-width: 500px;
  height: auto;
}

.exchange_complete {
  margin-top: 31px;
  font-size: 20px;
  line-height: 20px;
  font-weight: bold;
  text-align: center;
}

.exchange_thanks {
  margin-top: 8px;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #808080;
}

.primary_button {
  margin-top: 24px;
}

.line_wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 24px 16px 24px 16px;
  margin-top: 24px;
  margin-bottom: 16px;
  border-radius: 8px;
  border-style: solid;
  border-width: 1px;
  border-color: #e8e8e8;
}

.line_description {
  width: 100%;
  font-size: 12px;
  font-weight: 300;
  line-height: 12px;
  text-align: center;
  color: #0f0f0f;
  margin-bottom: 20px;
  letter-spacing: 0.4px;
}

#mypage__wrapper {
  position: relative;
  height: auto;
  min-height: 100%;
}

#mypage__container {
  font-family: 'Hiragino Sans', sans-serif;
  font-size: 14px;
  line-height: 1.43;
  color: #262626;
  padding: 0 16px 40px;

  @media (min-width: 800px) {
    width: 800px;
    margin: 0 auto;
  }
}
</style>
